/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import UserPreferences from '@ion/core/src/preferences/UserPreferences';

/**
 * Whether the user has already been shown the Create Job notifications banner.
 *
 * A flat key of its own rather than a field inside `jobssearch.watchedJobs`:
 * it must survive `unwatchAll`, and it is not part of the watch state. Both
 * keys live in the same `UserPreferences` singleton, so the two surfaces which
 * write them cannot disagree.
 */
export const JOB_NOTIFICATIONS_BANNER_SEEN = 'jobssearch.notificationsBannerSeen';

/**
 * Whether the banner has been dismissed - by either of the two things which
 * dismiss it, the Enable/Disable button or the alert's own close.
 *
 * Unlike the Vehicle Manager equivalent this takes no user id and never
 * initializes the store: `initializePreferences` has already run for the signed
 * in user long before a dialog can render. The guard is what keeps the module
 * testable in isolation, and it answers `false` - show the banner - rather than
 * throwing if that assumption is ever broken.
 */
export const getBannerSeen = async(): Promise<boolean> => (
  UserPreferences.isInitialized()
    ? !!UserPreferences.get(JOB_NOTIFICATIONS_BANNER_SEEN)
    : false
);

/**
 * Marks the banner permanently dismissed. `true` for the immediate argument
 * makes `set` perform the save itself, so there is no window in which a reload
 * brings the banner back.
 */
export const setBannerSeen = async(): Promise<void> => {
  if (UserPreferences.isInitialized()) {
    await UserPreferences.set(JOB_NOTIFICATIONS_BANNER_SEEN, true, true);
  }
};
